<template>
  <div class="fx-table">
    <ul>
      <li class="table-header">
        <div
          :key="index"
          v-for="(item,index) in columns"
          :style="{width: item.width,justifyContent:item.align||'start'}"
          class="td"
        >{{item.title}}</div>
      </li>
    </ul>
    <div class="div-tbody">
      <ul ref="container" class="table-ul-tbody">
        <li
          v-if="!isDropRow"
          :key="dindex"
          :data-key="data.key||dindex"
          v-for="(data,dindex) in dataSource"
          class="table-tbody"
        >
          <div
            :key="index"
            v-for="(item,index) in columns"
            :style="{width: item.width,justifyContent:item.align||'start'}"
            class="td"
          >
            <div
              :title="data[item.dataIndex]"
              v-if="item.scopedSlots&&item.scopedSlots.customRender"
            >
              <slot :record="data" :index="dindex" :name="item.scopedSlots.customRender"></slot>
            </div>
            <div v-else>{{data[item.dataIndex]}}</div>
          </div>
        </li>
        <li
          v-if="isDropRow"
          :key="dindex"
          :data-key="data.key||dindex"
          v-for="(data,dindex) in dataSource"
          class="table-tbody"
          draggable="true"
          @dragstart="drag($event,data)"
          @drop="drop($event,data)"
          @dragover="allowDrop($event)"
        >
          <div
            :key="index"
            :style="{width: item.width,justifyContent:item.align||'start'}"
            v-for="(item,index) in columns"
            class="td"
          >
            <div
              :title="data[item.dataIndex]"
              v-if="item.scopedSlots&&item.scopedSlots.customRender"
            >
              <slot
                :text="data[item.dataIndex]"
                :record="data"
                :index="dindex"
                :name="item.scopedSlots.customRender"
              ></slot>
            </div>
            <div :title="data[item.dataIndex]" v-else>{{data[item.dataIndex]}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Array,
      required: true
      // default: []
    },
    columns: {
      type: Array,
      required: true
      // default: []
    },
    isDropRow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    isDropRow(val) {
      if (!val) {
        this.$refs.container.querySelectorAll(".table-tbody").forEach(ele => {
          ele.setAttribute("draggable", "false");
        });
      }
    }
  },
  data() {
    return {
      startDom: null,
      startItem: null,
      tableId: "table-" + new Date().getTime()
    };
  },
  mounted() {
    // console.log(this.dataSource, this.columns)
  },
  methods: {
    drag: function(event, item) {
      this.startDom = event.currentTarget;
      this.startItem = item;
    },
    drop: function(event, item) {
      event.preventDefault();
      const endItem = item;
      // this.$refs.container.insertBefore(this.startDom, event.currentTarget);
      // this.$refs.container.insertBefore(this.startDom, event.currentTarget);
      this.$emit("drop", this.startItem, endItem);
    },
    allowDrop: function(event) {
      event.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.fx-table {
  overflow: auto;
  width: 100%;
  .table-tbody:hover {
    .td {
      background: #e6f7ff;
    }
  }
  .div-tbody {
    height: auto;
    overflow-x: hidden;
    display: inline-block;
    overflow-y: auto;
  }
  ul {
    margin: 0;
    padding: 0;
    display: flex;
    width: 100%;
    flex-wrap: wrap;
  }
  ul li {
    list-style-type: none;
    display: flex;
    width: 100%;
    // overflow: hidden;
    white-space: nowrap;
    margin: 0;
  }
  .td {
    min-height: 20px;
    padding: 16px;
    margin: 0;
    display: flex;
    width: 100px;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    border-bottom: 1px solid rgb(232, 232, 232);
    div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .table-header {
    // width: 100%;
    white-space: nowrap;
    // background: rgb(250, 250, 250);
    .td {
      background: rgb(250, 250, 250);
    }
  }
}
</style>
